import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { InvoiceWithRelationsDto, ResponseDto } from "@mimber/schema"
import { invoicesKeys } from "../invoices.utils"

interface IssueInvoiceOptions extends Omit<
  UseMutationOptions<ResponseDto<InvoiceWithRelationsDto>, Error, void>,
  "mutationFn"
> {}

export const useIssueInvoice = (
  uuid: string,
  options: IssueInvoiceOptions = {}
): UseMutationResult<ResponseDto<InvoiceWithRelationsDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useIssueInvoice")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<InvoiceWithRelationsDto>>(
        `invoices/${uuid}/issue`,
        {}
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: invoicesKeys.findOne(uuid) })
      queryClient.invalidateQueries({ queryKey: invoicesKeys.findAll() })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
